import './assets/css/style.css';
import iniciar from './modules/formularios';

(function(){

    iniciar();
    
})();
